import { gql } from '@apollo/client';
import type { ApolloCache, StoreObject } from '@apollo/client';
import type { RealtimeStrategy } from './realtimeStrategy';

export const INSERT_PREFIX = 'insertIntoProjectField:';

interface RealtimeChange {
	strategy: RealtimeStrategy;
	type: string;
	projectId: string;
	details: StoreObject;
	changes: Record<string, unknown>;
	changeFunctions: Record<string, () => unknown>;
}

// Applique au cache Apollo un changement reçu par onProjectChange.
// Les `cache.modify` diffusent (broadcast par défaut) : les vues abonnées
// (radar, listes, jauges) se re-rendent dès la réception de l'événement.
// Avec `broadcast: false`, le changement restait invisible jusqu'à la
// prochaine écriture du cache — un lecteur inactif voyait chaque action
// avec un temps de retard.
export const applyRealtimeChange = (cache: ApolloCache<any>, change: RealtimeChange): void => {
	const { strategy, type, projectId, details, changes, changeFunctions } = change;

	if (strategy.startsWith(INSERT_PREFIX)) {
		cache.modify({
			id: 'Project:' + projectId,
			fields: {
				[strategy.slice(INSERT_PREFIX.length)]: (values) => {
					const newElement = cache.writeFragment({
						id: cache.identify(details),
						data: details,
						fragment: gql`
							fragment ConstraintFragment on ${type} {
								${['id', ...Object.keys(changes)].join('\n')}
							}
						`
					});

					return [...((values as readonly unknown[] | undefined) ?? []), newElement];
				}
			}
		});
	} else if (strategy === 'modifyScalars') {
		cache.modify({
			id: cache.identify(details),
			fields: changeFunctions
		});
	}
};
